import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import CounselorCoupleDetailPage from './pages/CounselorCoupleDetailPage';
// Pages
import LandingPage from './pages/LandingPage';
import CoupleAuth from './pages/CoupleAuth';
import CounselorAuth from './pages/CounselorAuth';
import CoupleDashboard from './pages/CoupleDashboard';
import CounselorDashboard from './pages/CounselorDashboard';
import QuizPage from './pages/QuizPage';
import ResultsPage from './pages/ResultsPage';
import FactorResultsPage from './pages/FactorResultsPage';
import IntensiveQuizPage from './pages/IntensiveQuizPage';
import IntensiveResultsPage from './pages/IntensiveResultsPage';
import MarriageReadinessTest from './pages/MarriageReadinessTest';
import ActionPlan from './pages/ActionPlan';  // <-- ADD THIS

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/couple/auth" element={<CoupleAuth />} />
          <Route path="/counselor/auth" element={<CounselorAuth />} />
          <Route path="/marriage-readiness-test" element={<MarriageReadinessTest />} />
          <Route path="/action-plan" element={<ActionPlan />} />

          {/* Couple Protected Routes */}
          <Route
            path="/couple/dashboard"
            element={
              <ProtectedRoute requireRole="couple">
                <CoupleDashboard />
              </ProtectedRoute>
            }
          />

          {/* Regular Assessment Quiz */}
          <Route
            path="/quiz"
            element={
              <ProtectedRoute requireRole="couple">
                <QuizPage />
              </ProtectedRoute>
            }
          />

          {/* Regular Assessment Results */}
          <Route
            path="/results"
            element={
              <ProtectedRoute requireRole="couple">
                <ResultsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/factor-results/:factorNumber"
            element={
              <ProtectedRoute requireRole="couple">
                <FactorResultsPage />
              </ProtectedRoute>
            }
          />

          {/* ===== PRE-MARRIAGE INTENSIVE ROUTES ===== */}
          <Route
            path="/intensive/quiz"
            element={
              <ProtectedRoute requireRole="couple">
                <IntensiveQuizPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/intensive/results/:moduleNumber"
            element={
              <ProtectedRoute requireRole="couple">
                <IntensiveResultsPage />
              </ProtectedRoute>
            }
          />
          {/* ===== END INTENSIVE ROUTES ===== */}

          {/* Counselor Protected Routes */}
          <Route
            path="/counselor/dashboard"
            element={
              <ProtectedRoute requireRole="counselor">
                <CounselorDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/counselor/couple/:coupleId"
            element={
              <ProtectedRoute requireRole="counselor">
                <CounselorCoupleDetailPage />
              </ProtectedRoute>
            }
          />

          {/* Fallback Route */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
